import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class TrendsFeedbackChartsService extends BaseService {
  constructor() {
    super(constants.GET_AI_CHARTS_UTILITY_DATA, 'TrendsFeedbackChartsService');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackbv2').post(`/trends/count/feedback`, payload, { headers: enhancedHeaders });
    }
    // Default flow: aiadminv2 with automatic token handling
    return this.getClient('aiadminv2').post(`/trends/count/feedback`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success' && data?.data?.length > 0) {
      Framework.getStoreRegistry().getStore('trendsFeedbackChartsUtility').setResponse(response.data);
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Data not found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('trendsFeedbackChartsUtility').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('trendsFeedbackChartsUtility').resetStoreValues();
  }
}
